// extracted by mini-css-extract-plugin
export default {"App":"App_App__nxAVZ","App-logo":"App_App-logo__EZ0XM","App-logo-spin":"App_App-logo-spin__uoWB6","App-header":"App_App-header__Xv+8T","App-link":"App_App-link__I67+E"};